import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import IconExternalLink from "components/partials/IconExternalLink";
import DrupalContext from 'contexts/DrupalContext'

export function FacetsSublinks() {
  const { t, i18n } = useTranslation()
  const drupal = useContext(DrupalContext)
  const links = {
    research: [{
      displayName: t('Search for publications'),
      url: i18n.language === 'sv'
        ? 'https://www.ub.gu.se/gup-sok'
        : 'https://www.ub.gu.se/gup-search',
    }],
  }[drupal.niche] || []

  return Boolean(links.length) && (
    <div className='layout layout--gray'>
      <div className='layout__container layout__container--dynamic u-height-auto u-pb-150 u-pb-200-large-up'>
        <div className='layout__inner row'>
          <div className='columns small-12'>
            {!!links.length && links.map(({ displayName, url }) => (
              <a className='link u-font-weight-700' href={url}>
                {displayName}
                <IconExternalLink />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FacetsSublinks
